import { FieldParameter } from "../../../../../../../../../../../Common/SchemaForm/Fields"
import {
    MappingsObjectTemplate,
    ArrayParameterTemplate
} from "../../../../../../../../../../../Common/SchemaForm/Templates"
import {
    TextWidget,
    SelectWidget,
    CheckboxWidget,
    TrainingSelectWidget
} from "../../../../../../../../../../../Common/SchemaForm/Widgets"

export const uiSchema = {
    "ui:enumDisabled": ["BotWorker"],
    pay: {
        "ui:field": FieldParameter,
        "ui:widget": TextWidget
    },
    name: {
        "ui:field": FieldParameter,
        "ui:widget": TextWidget
    },
    type: {
        "ui:widget": "hidden"
    },
    active: {
        "ui:field": FieldParameter,
        "ui:widget": CheckboxWidget
    },
    distinct: {
        "ui:field": FieldParameter,
        "ui:widget": CheckboxWidget
    },
    timeout: {
        "ui:field": FieldParameter,
        "ui:widget": TextWidget
    },
    numTasks: {
        "ui:field": FieldParameter,
        "ui:widget": TextWidget
    },
    onTimeout: {
        action: {
            "ui:field": FieldParameter,
            "ui:widget": SelectWidget
        },
        maxRetries: {
            "ui:field": FieldParameter,
            "ui:widget": TextWidget
        }
    },
    description: {
        "ui:field": FieldParameter,
        "ui:widget": TextWidget
    },
    confidenceThreshold: {
        "ui:field": FieldParameter,
        "ui:widget": TextWidget
    },
    fieldMappings: {
        "ui:ObjectFieldTemplate": MappingsObjectTemplate
    },
    workerConstraints: {
        additionalProperties: {
            "ui:widget": "hidden"
        },
        email: {
            "ui:ArrayFieldTemplate": ArrayParameterTemplate,
            items: {
                "ui:widget": TextWidget
            }
        },
        groups: {
            "ui:ArrayFieldTemplate": ArrayParameterTemplate,
            items: {
                "ui:widget": TextWidget
            }
        },
        workerId: {
            "ui:ArrayFieldTemplate": ArrayParameterTemplate,
            items: {
                "ui:widget": TextWidget
            }
        },
        excludedGroups: {
            "ui:ArrayFieldTemplate": ArrayParameterTemplate,
            items: {
                "ui:widget": TextWidget
            }
        },
        trainingId: {
            "ui:widget": TrainingSelectWidget
        }
    }
}
